/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DueState } from './DueState';
import {
    DueStateFromJSON,
    DueStateFromJSONTyped,
    DueStateToJSON,
} from './DueState';
import type { JobFrequency } from './JobFrequency';
import {
    JobFrequencyFromJSON,
    JobFrequencyFromJSONTyped,
    JobFrequencyToJSON,
} from './JobFrequency';
import type { JobState } from './JobState';
import {
    JobStateFromJSON,
    JobStateFromJSONTyped,
    JobStateToJSON,
} from './JobState';
import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';

/**
 * 
 * @export
 * @interface JobOccurrenceFilterOptionsDto
 */
export interface JobOccurrenceFilterOptionsDto {
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    id?: number;
    /**
     * 
     * @type {Array<MedicalSystemCatalogDto>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    targetSystems?: Array<MedicalSystemCatalogDto> | null;
    /**
     * 
     * @type {Array<JobFrequency>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    recurrences?: Array<JobFrequency> | null;
    /**
     * 
     * @type {Array<JobState>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    states?: Array<JobState> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<DueState>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    dueStates?: Array<DueState> | null;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    reviewsRequired?: Array<boolean> | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    $type?: JobOccurrenceFilterOptionsDtoTypeEnum;
}


/**
 * @export
 */
export const JobOccurrenceFilterOptionsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceFilterOptionsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceFilterOptionsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobOccurrenceFilterOptionsDtoTypeEnum = typeof JobOccurrenceFilterOptionsDtoTypeEnum[keyof typeof JobOccurrenceFilterOptionsDtoTypeEnum];



/**
 * Check if a given object implements the JobOccurrenceFilterOptionsDto interface.
 */
export function instanceOfJobOccurrenceFilterOptionsDto(value?: unknown): value is JobOccurrenceFilterOptionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobOccurrenceFilterOptionsDtoTypeEnum)[0];
}

export function JobOccurrenceFilterOptionsDtoFromJSON(json: any): JobOccurrenceFilterOptionsDto {
    return JobOccurrenceFilterOptionsDtoFromJSONTyped(json, false);
}

export function JobOccurrenceFilterOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceFilterOptionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'targetSystems': json['targetSystems'] == null ? undefined : ((json['targetSystems'] as Array<any>).map(MedicalSystemCatalogDtoFromJSON)),
        'recurrences': json['recurrences'] == null ? undefined : ((json['recurrences'] as Array<any>).map(JobFrequencyFromJSON)),
        'states': json['states'] == null ? undefined : ((json['states'] as Array<any>).map(JobStateFromJSON)),
        'assignedUserIds': json['assignedUserIds'] == null ? undefined : json['assignedUserIds'],
        'assignedRoleIds': json['assignedRoleIds'] == null ? undefined : json['assignedRoleIds'],
        'dueStates': json['dueStates'] == null ? undefined : ((json['dueStates'] as Array<any>).map(DueStateFromJSON)),
        'reviewsRequired': json['reviewsRequired'] == null ? undefined : json['reviewsRequired'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function JobOccurrenceFilterOptionsDtoToJSON(value?: JobOccurrenceFilterOptionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'targetSystems': value['targetSystems'] == null ? undefined : ((value['targetSystems'] as Array<any>).map(MedicalSystemCatalogDtoToJSON)),
        'recurrences': value['recurrences'] == null ? undefined : ((value['recurrences'] as Array<any>).map(JobFrequencyToJSON)),
        'states': value['states'] == null ? undefined : ((value['states'] as Array<any>).map(JobStateToJSON)),
        'assignedUserIds': value['assignedUserIds'],
        'assignedRoleIds': value['assignedRoleIds'],
        'dueStates': value['dueStates'] == null ? undefined : ((value['dueStates'] as Array<any>).map(DueStateToJSON)),
        'reviewsRequired': value['reviewsRequired'],
        '$type': value['$type'],
    });
}

